"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requiredOnboardingMerchIdSelector = exports.requiredOnboardingSelector = void 0;

var requiredOnboardingSelector = function requiredOnboardingSelector(state) {
  var requiredOnboarding = state.requiredOnboarding;
  return requiredOnboarding;
};

exports.requiredOnboardingSelector = requiredOnboardingSelector;

var requiredOnboardingMerchIdSelector = function requiredOnboardingMerchIdSelector(state, merchId) {
  var requiredOnboarding = requiredOnboardingSelector(state);

  if (!requiredOnboarding[merchId] || !requiredOnboarding[merchId].onboardingRequired) {
    return null;
  }

  return requiredOnboarding[merchId].onboardingMerchandiseId;
};

exports.requiredOnboardingMerchIdSelector = requiredOnboardingMerchIdSelector;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/RequiredOnboardingSelectors.js
// module id = 183
// module chunks = 5 6 7